export const REMEMBER_ME = "rememberMe";
export const SESSION_ID = "sessionId";
export const LOGIN_TOKEN = "loginToken";
